/*
 * SQ bundle selector — snippets/sq-selector.liquid
 * Card state, free gifts panel and add to cart (subscription product).
 * Standalone: not tied to the old .product-selector_* markup / buy-page.js.
 */
(function () {
  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  // Carry utm* params from the page URL over to the champs checkout URLs
  function withUtms(url) {
    if (!url) return url;
    var utms = [];
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      var k = key.toLowerCase();
      if (k === "utm" || k.indexOf("utm_") === 0) utms.push([key, value]);
    });
    if (!utms.length) return url;
    var parts = url.split("?");
    var params = new URLSearchParams(parts[1] || "");
    utms.forEach(function (utm) {
      if (!params.has(utm[0])) params.append(utm[0], utm[1]);
    });
    return parts[0] + "?" + params.toString();
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (response) {
      if (!response.ok) throw new Error(url + " " + response.status);
      return response.json();
    });
  }

  function trackKlaviyo(input) {
    if (!window.klaviyo) return;
    var price = parseFloat(input.dataset.price || 0) / 100;
    klaviyo.push([
      "track",
      "Added to Cart",
      {
        $value: price,
        AddedItemProductName: input.dataset.title || "",
        AddedItemProductID: input.dataset.variantId || "",
        AddedItemSKU: input.dataset.variantId || "",
        AddedItemImageURL: input.dataset.image || "",
        AddedItemURL: input.dataset.url || window.location.href,
        AddedItemPrice: price,
        AddedItemQuantity: 1,
      },
    ]);
  }

  function init(root) {
    if (root.dataset.sqsReady) return;
    root.dataset.sqsReady = "true";

    var section = root.closest(".shopify-section") || document;
    var cards = [].slice.call(root.querySelectorAll(".sqs-opt"));
    var gifts = [].slice.call(root.querySelectorAll(".sqs-gift"));
    var bars = [].slice.call(root.querySelectorAll(".sqs-bar i"));
    var nexts = [].slice.call(root.querySelectorAll("[data-sqs-next]"));
    var count = root.querySelector("[data-sqs-count]");
    var saved = root.querySelector(".sqs-saved");
    var saveValue = root.querySelector("[data-sqs-save-value]");
    var atc = section.querySelector("[data-sqs-atc]");
    var shownSave = 0;
    var frame = null;

    function checkedInput() {
      return root.querySelector(".sqs-opt input:checked");
    }

    function countTo(to, label, animate) {
      if (!saveValue) return;
      if (frame) cancelAnimationFrame(frame);
      if (!animate || reduceMotion || to === shownSave) {
        saveValue.textContent = label;
        shownSave = to;
        return;
      }
      var from = shownSave;
      var start = performance.now();
      frame = requestAnimationFrame(function step(now) {
        var k = Math.min(1, (now - start) / 450);
        var value = from + (to - from) * (1 - Math.pow(1 - k, 3));
        saveValue.textContent = k < 1 ? formatMoney(Math.round(value)) : label;
        if (k < 1) frame = requestAnimationFrame(step);
        else shownSave = to;
      });
    }

    function update(animate) {
      var input = checkedInput();
      if (!input) return;

      var card = input.closest(".sqs-opt");
      var unlocked = +card.dataset.sqsGifts || 0;
      var pos = card.dataset.sqsPos;

      cards.forEach(function (opt) {
        opt.classList.toggle("is-on", opt === card);
      });

      gifts.forEach(function (gift, i) {
        var on = unlocked > i;
        var wasOn = !gift.classList.contains("is-locked");
        gift.classList.toggle("is-locked", !on);
        if (on && !wasOn && animate) {
          gift.classList.remove("is-pop");
          void gift.offsetWidth;
          gift.classList.add("is-pop");
        }
      });
      bars.forEach(function (bar, i) {
        bar.classList.toggle("is-on", i < unlocked);
      });
      if (count) count.textContent = Math.min(unlocked, gifts.length) + "/" + gifts.length;

      var save = +card.dataset.sqsSave || 0;
      // No savings row for offers without gifts (1 tub)
      if (saved) saved.hidden = unlocked === 0 || save <= 0;
      countTo(save, card.dataset.sqsSaveLabel, animate);

      nexts.forEach(function (next) {
        next.hidden = next.dataset.sqsNext !== pos;
      });

      // Per-variant refill frequency notes under the add to cart button
      section.querySelectorAll(".cta-note.changeble").forEach(function (note) {
        note.classList.toggle("hided", note.dataset.id !== input.dataset.index);
      });
      section.querySelectorAll(".product_atc-refills").forEach(function (note) {
        note.classList.toggle("hided", note.getAttribute("data") !== input.dataset.index);
      });
    }

    function select(pos) {
      var input = root.querySelector('.sqs-opt[data-sqs-pos="' + pos + '"] input');
      if (!input) return;
      input.checked = true;
      update(true);
    }

    function addToCart() {
      var input = checkedInput();
      if (!input || atc.classList.contains("is-loading")) return;

      if (atc.dataset.modeChamps === "true") {
        trackKlaviyo(input);
        window.location.href = withUtms(input.dataset.cocUrl);
        return;
      }

      var item = { id: +input.dataset.variantId, quantity: 1 };
      if (input.dataset.sellingPlan) item.selling_plan = +input.dataset.sellingPlan;
      var items = { items: [item] };

      atc.classList.add("is-loading");
      var request;
      if (atc.dataset.checkout === "true") {
        document.querySelectorAll("kaching-cart").forEach(function (cart) {
          cart.style.display = "none";
        });
        request = postJSON("/cart/clear.js")
          .then(function () {
            return postJSON("/cart/add.js", items);
          })
          .then(function () {
            window.location.href = "/checkout";
          });
      } else {
        request = postJSON("/cart/add.js", items);
      }
      request
        .catch(function () {
          alert(atc.dataset.error || "Error adding item to the cart.");
        })
        .then(function () {
          atc.classList.remove("is-loading");
        });
    }

    root.addEventListener("change", function () {
      update(true);
    });

    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-sqs-to]");
      if (!button) return;
      event.preventDefault();
      select(button.dataset.sqsTo);
    });

    if (atc) atc.addEventListener("click", addToCart);

    update(false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-sqs]").forEach(init);
  }

  initAll();
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
